import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "../context/UserContext";

const STAFF_ROLES = ["ADMIN", "MANAGER", "STAFF"];

/**
 * Wraps staff-only routes; patient-only accounts are sent to /403.
 */
const StaffRoutes = () => {
  const { roles, canSwitchPersona, activePersona } = useUserContext();
  const upper = (roles || []).map((r) => String(r || "").toUpperCase());
  const allowed = upper.some((r) => STAFF_ROLES.includes(r));
  if (!allowed) {
    return <Navigate to="/403" replace />;
  }
  if (canSwitchPersona && activePersona === "patient") {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default StaffRoutes;
